import { Controller } from "@hotwired/stimulus"

// A choice read as a line of words: a mark that follows it - a globe for
// everyone, a lock for only me, an hourglass once a post is set to disappear -
// the word chosen, and the menu itself laid over the pair, unseen. The marks
// are all in the page; this shows the one whose key matches the chosen value
// (a "circle:slug" value matches the "circle" mark), and writes the chosen
// word where a reader sees it. The word is what gives the choice its width,
// so the chevron sits against it and no menu is measured.
export default class extends Controller {
  static targets = ["select", "mark", "word"]

  connect() {
    this.pick()
  }

  pick() {
    const key = this.selectTarget.value.split(":")[0]
    let shown = false
    this.markTargets.forEach((mark) => {
      const matches = mark.dataset.choiceKey.split(" ").includes(key)
      // The marks are SVGs, which have no `hidden` property; the attribute is what the CSS reads.
      mark.toggleAttribute("hidden", !matches || shown)
      if (matches) shown = true
    })

    const chosen = this.selectTarget.options[this.selectTarget.selectedIndex]
    if (this.hasWordTarget && chosen) this.wordTarget.textContent = chosen.text
  }
}
